// extracted by mini-css-extract-plugin
export default {"wrap":"banner_wrap__fxP7x","section":"banner_section__8n7MS","img":"banner_img__XgYsY","imgLink":"banner_imgLink__SDhVv"};